import { db, firefunctions } from './../config/firebase.config';
const Collection = db.collection('PointdeRetrait')



const PointdeRetrait = {
    stream: (callback) => Collection.onSnapshot(snap => {
        const data = snap.docs.map(doc => doc.data())
        if (callback)
            callback(data)
    }),
    fetch: async () => {
        let pdr = []
        const data = await Collection.get();
        data.docs.forEach(item => {
            pdr.push(item.data())
        })
        return pdr
    },
    update: async (pdr) => Collection.doc(pdr.id).update(pdr),
    get: async (id) => {
        const data = await Collection.doc(id).get();
        return data.data()
    },
    getstate: async () => {
        try {
            const fire_getpointderetrait = firefunctions.httpsCallable('getpointderetrait');
            let json = await fire_getpointderetrait()
            return json.data;
        } catch (error) {

        }
    }
}



const add = () => {
    /*let pdr = require('../config/pointsderetraits.json');
    let PointdeRetrait = pdr.data.map(x => {
        x.heurefermeture = { heure: 16, minute: 45 }
        x.opened = false
        return x;
    })
    PointdeRetrait.forEach(pdr => {

        Collection
            .doc(pdr.id)
            .set(pdr)
            .then(function () {
                console.log("Value successfully written!");
            })
    })*/
}

export default PointdeRetrait;